import React from 'react';
import AcademicWorkspace from './AcademicWorkspace';

export default function StudentAcademics() {
    return <div style={{ maxWidth: 1240, margin: '0 auto', padding: '2rem 1rem' }}>
        <AcademicWorkspace defaultTab="courses" />
    </div>;
}
